<template>
    <div>
        <div class="row text-center justify-content-center" id="HeadlineDescription">
            <div class="col-md-8">
                <h3>{{headline}}</h3>
            </div>
        </div>
        <div class="mt-5 row text-center justify-content-center">
            <div class="col-md-8">
                <ScrambleText ref="childRef" v-bind:text=description :playAudio="false" />
            </div>
        </div>
        <div v-if="projects.length" class="project-cards-row mt-5">
            <div v-for="project in projects" :key="project.slug" class="project-card-wrapper mb-4">
                <router-link :to="`${basePath}/${project.slug}`" class="project-link">
                    <div class="card h-100">
                        <img :src="getImgUrl(project.headerImage)" class="card-img-top" :alt="project.title">
                        <div class="card-body">
                            <ScrambleTextLink :msg="project.title" :linkTo="`${basePath}/${project.slug}`" />
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import ScrambleText from './ScrambleText.vue';
import ScrambleTextLink from './ScrambleTextLink.vue';
const images = require.context('@/assets/img', true, /\.(png|jpe?g|svg|webp)$/);
export default {
    name: 'ProjectDescriptionText',
    data() {
        return {
            headline: '',
            description: '',
            projects: [],
        }
    },
    props: {
        basePath: {
            type: String,
            required: true,
        },
        jsonData: {
            type: Object,
            required: false,
        }
    },
    components: {
        ScrambleText,
        ScrambleTextLink
    },
    methods: {
        getImgUrl(path) {
            if (!path) return '';
            const cleanPath = path.replace(/^\//, '');
            try {
                return images('./' + cleanPath);
            } catch (e) {
                return '';
            }
        }
    },
    mounted() {
        if (this.jsonData) {
            this.headline = this.jsonData.Headline;
            this.description = this.jsonData.Description;
            this.projects = this.jsonData.Projects || [];
            if (this.$refs.childRef) {
                this.$refs.childRef.initScrambleWithText(this.description, 0.1, 0.7);
            }
        }
    }
}
</script>

<style>
#HeadlineDescription {
    margin-top: 5rem;
}
.card {
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.project-link {
    text-decoration: none;
    color: inherit;
}
.project-link:hover {
    text-decoration: underline;
    color: inherit;
}
.card-img-top {
    width: 100%;
    height: auto;
    max-height: 18rem; /* optional: limits height but allows scaling */
    object-fit: contain; /* ensures the whole image is visible */
    display: block;
    overflow: hidden;
}
.card-body {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    margin-top: 0;
}
.project-cards-row {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;
    margin: 0 auto;
    justify-items: center;
}
.project-card-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
}
</style>